"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _jsxFileName = "src/icons/CircleSocialGooglePlus.js";
var _react = require("react");
var _react2 = _interopRequireDefault(_react);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var CircleSocialGooglePlus = function CircleSocialGooglePlus(props) {
  return _react2.default.createElement("svg", Object.assign({
    className: "circle-icon",
    viewBox: "0 0 515 515"
  }, props, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 4
    },
    __self: undefined
  }), _react2.default.createElement("title", {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 5
    },
    __self: undefined
  }, "Google Circle Icon"), _react2.default.createElement("path", {
    d: "M257.5 0C115.29 0 0 115.29 0 257.5S115.29 515 257.5 515 515 399.71 515 257.5 399.71 0 257.5 0zm82.14 281.06c-10.92 53.79-60.84 94.28-117.85 94.28a117.84 117.84 0 1 1 82.46-202l-26.61 28.93a78.55 78.55 0 1 0 19.11 78.81h-67.1V244.4h110v36.66zm71.44-17.44h-22.53v22.5H369.3v-22.5h-22.5v-19.28h22.5v-22.5h19.28v22.5h22.5v19.28z",
    className: "circle-google-plus",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 6
    },
    __self: undefined
  }));
};
exports.default = CircleSocialGooglePlus;